import { Component } from '@angular/core';

@Component({
  selector: 'alt-event-wrapper-page',
  templateUrl: './event-wrapper.page.html',
  styleUrls: ['./event-wrapper.page.scss'],
})
export class EventWrapperPage {}
